<template>
  <el-dialog
    v-model="DLGVisible"
    :title="DLGTitle"
    :before-close="closeDLG"
    modal-class="insufficient-token-dialog"
    width="420"
    align-center
  >
    <template #header>
      <div class="dialog-header">
        <img src="@/assets/images/token.png" class="llm" />
        <span class="title">Token不足请充值！</span>
      </div>
    </template>
    <div class="token-warning">
      <div class="content">
        <span>AI功能</span>
        需要消耗Token数，您可以充值Token或
      </div>
      <a href="/pricing" class="href">升级版本，免费获取Token</a>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button
          type="primary"
          class="button"
          @click="handleClickPurchaseToken"
        >
          充值Token
        </el-button>
      </div>
    </template>
  </el-dialog>
  <DialogTokenPurchase ref="dialogTokenPurchaseRef" />
</template>

<script setup>
import {
  ref,
  nextTick,
  defineExpose,
  computed,
  defineEmits,
  defineProps,
  watch,
} from "vue";
import { httpPost } from "@/api/httpService";
import { ElMessage } from "element-plus";
import DialogTokenPurchase from "@/components/user/DialogTokenPurchase.vue";

// 弹窗相关
const DLGVisible = ref(false);
const DLGTitle = ref("Token数明细");
const openDLG = () => {
  DLGVisible.value = true;
};
const closeDLG = () => {
  DLGVisible.value = false;
};

//购买token
const dialogTokenPurchaseRef = ref(null);
const handleClickPurchaseToken = () => {
  dialogTokenPurchaseRef.value.openDLG();
};

defineExpose({ openDLG, closeDLG });
</script>

<style lang="scss" scoped>
.dialog-header {
  display: flex;
  align-items: center;
  padding-left: 30px;
  position: relative;
  top: 15px;
  .llm {
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .title {
    font-size: 18px;
    font-weight: 550;
  }
}
.token-warning {
  padding: 30px 30px 0 30px;
  .content {
    span {
      color: #844505;
      font-weight: 550;
    }
    margin-bottom: 10px;
  }
  .href:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}
.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px 20px 20px;
  .button {
    background: linear-gradient(
      138.57deg,
      rgba(255, 220, 158, 1) -1.68%,
      rgba(255, 236, 179, 1) 104.53%
    );
    border: none;
    height: 34px;
    width: 120px;
    color: rgba(132, 69, 5, 1);
  }
}
</style>
<style lang="scss">
.insufficient-token-dialog {
  .el-dialog {
    border-radius: 15px;
  }
  .el-dialog__header {
    border: none;
  }
}
</style>
